import { createRouter } from '@tanstack/react-router';

import { Spinner } from '@vestigas/ui/molecules';

import { RootErrorBoundary } from './components';
import { routeTree } from './routerConfig';
import { type RouterContext } from './types';

export const tanstackRouter = (context: RouterContext) =>
  createRouter({
    context,
    defaultErrorComponent: ({ error }) => <RootErrorBoundary error={error} />,
    defaultNotFoundComponent: () => (
      <RootErrorBoundary error={{ status: 404 }} />
    ),
    defaultPendingComponent: () => (
      <div className="flex size-full min-h-0 flex-1 items-center justify-center">
        <Spinner />
      </div>
    ),
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
    routeTree,
  });

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof tanstackRouter>;
  }
}
